import { Spin } from 'antd'
import React from 'react'

const Loader = ({text}) => {
  return (
    <div>
        <Spin size="large" />
        {text && <div className="mt-2 text-center text-gray-600">{text}</div>}
    </div>
  )
}

export default Loader